import { create } from "zustand";
import { persist } from "zustand/middleware";

interface StoryboardHistoryState {
  visitedUrls: Record<string, Record<string, number>>;
  addVisitedUrl: (url: string, projectId: string) => void;
  removeVisitedUrl: (url: string, projectId: string) => void;
}

export const useStoryboardHistoryStore = create<StoryboardHistoryState>()(
  persist(
    (set) => ({
      visitedUrls: {},
      addVisitedUrl: (url, projectId) =>
        set((state) => ({
          visitedUrls: {
            ...state.visitedUrls,
            [projectId]: {
              ...state.visitedUrls[projectId],
              [url]: Date.now(),
            },
          },
        })),
      removeVisitedUrl: (url, projectId) =>
        set((state) => ({
          visitedUrls: {
            ...state.visitedUrls,
            [projectId]: Object.fromEntries(
              Object.entries(state.visitedUrls[projectId]).filter(
                ([key]) => key !== url,
              ),
            ),
          },
        })),
    }),
    {
      name: "storyboard-url-storage",
    },
  ),
);
